module.exports = __webpack_public_path__ + "img/block_circle.e0ce3fa2.gif";